import { Box, Button, Typography, styled, useTheme } from "@mui/material";

import React from "react";

function SecurityItem({ icon, title, status, onClick }) {
  const theme = useTheme()
  return (
    <SecurityItemWrapper>
      <SecurityItemName>
        {icon}
        <Typography variant="h5">{title}</Typography>
      </SecurityItemName>

      <Button
        size="small"
        color={status ? "error" : theme.mode === 'primary' ? "secondary" : "primary"}
        dark="true"
        onClick={onClick}
      >
        {status ? "غیر فعال کردن" : "فعال کردن"}
      </Button>
    </SecurityItemWrapper>
  );
}

const SecurityItemWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  borderRadius: 10,
  padding: theme.spacing(1.5, 2),
  display: "flex",
  alignItems: "center",
  flexDirection: "row-reverse",
  justifyContent: "space-between",
}));

const SecurityItemName = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "row-reverse",

  "ion-icon": {
    width: "20px",
    height: "20px",
  },

  ".MuiTypography-root": {
    marginRight: theme.spacing(2),
    lineHeight: "initial",
  },
}));

export default SecurityItem;
